import React, { useState, useEffect, useRef } from 'react';
import { downloadCsv } from '../common/sharedFunctions';
import MaterialTable from 'material-table';
import { useSelector, useDispatch } from 'react-redux';
import CircularLoading from '../components/CircularLoading';
import { api } from 'common';
import { useTranslation } from 'react-i18next';
import moment from 'moment/min/moment-with-locales';
import { WEB_SECONDORY_COLOR } from '../common/sharedFunctions';
import { ThemeProvider } from '@mui/material/styles';
import theme from 'styles/tableStyle';
import TableStyle from '../components/Table/Style';
import localization from '../components/Table/Localization';

export default function UserReports() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector((state) => state.settingsdata.settings);
  const { fetchUserReports, updateUserReport } = api;
  const [data, setData] = useState([]);
  const reportdata = useSelector((state) => state.userreportdata.list);
  const dispatch = useDispatch();
  const loaded = useRef(false);
  const SECONDORY_COLOR = WEB_SECONDORY_COLOR(settings?.appCat);

  useEffect(() => {
    dispatch(fetchUserReports());
  }, [dispatch, fetchUserReports]);

  useEffect(() => {
    setData(reportdata || []);
    loaded.current = true;
  }, [reportdata]);

  const columns = [
    { title: t('createdAt'), field: 'createdAt', editable: 'never', defaultSort: 'desc', render: (row) => row.createdAt ? moment(row.createdAt).format('lll') : null },
    { title: t('reporter', { defaultValue: 'Reporta' }), field: 'reporterName', editable: 'never' },
    { title: t('reported_user', { defaultValue: 'Reportado' }), field: 'reportedName', editable: 'never' },
    { title: t('usertype'), field: 'reportedRole', editable: 'never' },
    { title: t('report_reason', { defaultValue: 'Motivo' }), field: 'reason', editable: 'never' },
    { title: t('message_text'), field: 'details', editable: 'never', cellStyle: { wordWrap: 'break-word', maxWidth: 320 } },
    { title: t('id'), field: 'bookingId', editable: 'never' },
    { title: t('context', { defaultValue: 'Contexto' }), field: 'context', editable: 'never' },
    { title: t('processDate'), field: 'processDate', editable: 'never', render: (row) => row.processDate ? moment(row.processDate).format('lll') : null },
    { title: t('status'), field: 'check', type: 'boolean', initialEditValue: false },
  ];

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    !loaded.current ? <CircularLoading /> :
      <ThemeProvider theme={theme}>
        <MaterialTable
          title={
            <div>
              <div>{t('user_reports_title', { defaultValue: 'Denuncias de usuarios' })}</div>
              <div style={{ fontSize: 13, fontWeight: 'normal', opacity: 0.85, marginTop: 4 }}>
                {t('user_reports_admin_hint', { defaultValue: 'Reportes enviados desde viajes o chat. Marca como revisado al cerrar el caso.' })}
              </div>
            </div>
          }
          columns={columns}
          style={{
            direction: isRTL === 'rtl' ? 'rtl' : 'ltr',
            borderRadius: '8px',
            boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
            padding: 5,
          }}
          data={data}
          onRowClick={(evt, selectedRow) => setSelectedRow(selectedRow.tableData.id)}
          options={{
            exportButton: true,
            exportCsv: (columns, rows) => {
              const hArray = [];
              const headerRow = columns.map((col) => {
                if (typeof col.title === 'object') return col.title.props?.text || '';
                hArray.push(col.field);
                return col.title;
              });
              const dataRows = rows.map(({ tableData, ...row }) => {
                const dArr = hArray.map((field) => row[field]);
                return dArr;
              });
              downloadCsv([headerRow, ...dataRows].map((e) => e.join(',')).join('\n'), 'user-reports.csv');
            },
            rowStyle: (rowData) => ({
              backgroundColor: selectedRow === rowData.tableData.id ? '#EEE' : '#FFF',
            }),
          }}
          localization={localization(t)}
          components={TableStyle}
          editable={{
            onRowUpdate: (newData) =>
              new Promise((resolve) => {
                dispatch(updateUserReport({ ...newData, status: newData.check ? 'reviewed' : 'pending' }));
                resolve();
              }),
          }}
        />
      </ThemeProvider>
  );
}
